Ext.define('SA.Chart', {
    singleton: true,

    addBackground(el) {
        var box = el.viewBox.baseVal;

        el.insertAdjacentElement('afterbegin', SA.Svg.create({
            type: 'rect',
            x: box.x,
            y: box.y,
            width: box.width,
            height: box.height,

            style: {
                fill: '#fff'
            }
        }));
    },

    create({padding, titleOffset, frameSize, titles, content}) {
        var el = SA.HiddenDom.attach(this.createEl({titles, content}));

        this.positionTitles({el, frameSize, offset: titleOffset});
        this.fitToContent({el, padding});
        this.addBackground(el);

        return el;
    },

    createEl({titles, content}) {
        return SA.Svg.create({
            type: 'svg',

            content: [
                {
                    type: 'g',
                    id: 'titles',

                    content: [
                        {type: 'g', position: 'above', content: titles.chart},
                        {type: 'g', position: 'left', content: titles.yAxis},
                        {type: 'g', position: 'below', content: titles.xAxis}
                    ]
                }, {
                    type: 'g',
                    id: 'content',
                    content
                }
            ]
        });
    },

    fitToContent({el, padding}) {
        var box = el.getBBox(),
            minX = box.x - padding,
            minY = box.y - padding,
            width = box.width + (padding * 2),
            height = box.height + (padding * 2),
            viewBox = `${minX} ${minY} ${width} ${height}`;

        SA.Svg.setAttrs(el, {width, height, viewBox});
    },

    positionTitles({el, frameSize, offset}) {
        var els = Array.from(el.querySelector('#titles').childNodes),
            contentRect = SA.Svg.getRect(el.querySelector('#content')),
            centerX = frameSize.width / 2,
            centerY = frameSize.height / 2;

        els.forEach(el => {
            var position = SA.Svg.getAttr(el, 'position'),
                xy = {
                    above: {x: centerX, y: 0 - SA.Svg.getRect(el).bottom - offset},
                    left: {x: contentRect.left - offset, y: centerY},
                    below: {x: centerX, y: contentRect.bottom + offset}
                }[position];

            SA.Svg.translate({el, ...xy});
        });
    }
});